import { create } from "zustand";

export type SmartNavigationState = {
  /** True if the user opted into smart navigation with the camera mode toggle button */
  isSmartNavigationEnabled: boolean;

  /** Change whether smart navigation is enabled */
  setIsSmartNavigationEnabled(isSmartNavigationEnabled: boolean): void;

  /** True while the smart navigation circle should be rendered over the 3D view */
  shouldShowSmartNavigationCircle: boolean;

  /** Change whether to show the smart navigation circle*/
  setShouldShowSmartNavigationCircle(show: boolean): void;
};

/** Store to share the smart navigation state between the 3D scene and the html overlay */
export const useSmartNavigationStore = create<SmartNavigationState>()(
  (set) => ({
    isSmartNavigationEnabled: false,
    setIsSmartNavigationEnabled(isSmartNavigationEnabled: boolean) {
      set({ isSmartNavigationEnabled });
    },
    shouldShowSmartNavigationCircle: false,
    setShouldShowSmartNavigationCircle(show: boolean) {
      set({ shouldShowSmartNavigationCircle: show });
    },
  }),
);
